import { gql } from "@apollo/client";

export const GET_GRUPO_OBLIGATORIO = gql`
query AllGrupoObligatorio {
    allGrupoObligatorio {
        idGrupoObligatorio
        descripcion
    }
}
`;